(()=>{
 const mobileNav=document.querySelector(".eo-conversion__mobile");
 if(mobileNav)document.body.append(mobileNav);
 const context=()=>document.querySelector('.eo-conversion');
 const track=(name)=>{
  const privacy=window.Shopify?.customerPrivacy;
  if(typeof privacy?.analyticsProcessingAllowed!=='function'||!privacy.analyticsProcessingAllowed())return;
  const data={page_path:location.pathname,product_handle:context()?.dataset.eoProduct||''};
  try{window.Shopify?.analytics?.publish('eoptimering:'+name,data);}catch{}
  if(typeof window.gtag==='function')window.gtag('event','eo_'+name,data);
 };
 const openBooking=()=>{
  const root=context();
  const native=document.getElementById('apntly-book-button');
  if(native&&native.getAttribute('aria-disabled')!=='true'){
   native.click();return;
  }
  document.querySelector('.product-form-wrapper')?.scrollIntoView({behavior:'smooth',block:'center'});
  if(root){const status=root.querySelector('[role="status"]');status.textContent=root.dataset.eoBookingFallback;status.hidden=false;}
 };
 document.addEventListener('click',event=>{
  const target=event.target.closest('[data-eo-booking],.eo-service-info__cta-button,[data-eo-action],a[href^="tel:"]');
  if(!target)return;
  if(target.hasAttribute('data-eo-booking')||target.classList.contains('eo-service-info__cta-button')){event.preventDefault();openBooking();return;}
  if(target.hasAttribute('data-eo-quote')){
   const url=new URL(target.href,location.origin);
   const form=document.querySelector('form[data-type="add-to-cart-form"]');
   const variant=form?.querySelector('input[name="id"]')?.value||context()?.dataset.eoVariant;
   if(variant)url.searchParams.set('variant',variant);
   target.href=url.pathname+url.search+url.hash;
  }
  if(target.dataset.eoAction)track(target.dataset.eoAction);
  else if(target.getAttribute('href')?.startsWith('tel:'))track('phone_clicked');
 });
 document.addEventListener('click',event=>{if(event.target.closest('#apntly-book-button'))track('booking_opened');},true);
 const formMarker=document.querySelector('[data-eo-enquiry-form]');
 if(formMarker){
  const form=formMarker.closest('form');
  const params=new URLSearchParams(location.search);
  const product=params.get('produkt');
  const textarea=form.querySelector('textarea');
  if(product&&textarea&&!textarea.value){
   textarea.value=formMarker.dataset.eoEnquiryPrefix+' '+product.slice(0,200)+'.\n\n'+formMarker.dataset.eoEnquiryPrompt;
   const subject=form.querySelector('select');
   if(subject){const option=Array.from(subject.options).find(o=>o.textContent.includes('Offert'));if(option)subject.value=option.value;}
   const variant=params.get('variant');
   if(variant&&/^\d+$/.test(variant)){const input=document.createElement('input');input.type='hidden';input.name='contact[Produktvariant]';input.value=variant;form.append(input);}
  }
  form.addEventListener('submit',()=>{if(form.checkValidity())track('enquiry_started');});
 }
 let successSent=false;
 const success=()=>{if(!successSent&&document.querySelector('[data-eo-enquiry-success]')){const privacy=window.Shopify?.customerPrivacy;if(privacy?.analyticsProcessingAllowed?.()){track('enquiry_submitted');successSent=true;}}};
 success();document.addEventListener('visitorConsentCollected',success);
})();
